import { withGalleryLightBoxCarouselProps } from 'viewModel/gallery/withGalleryLightBoxCarouselProps';
import GalleryLightBoxCarousel from 'components/Community/GalleryLightBoxCarousel/GalleryLightBoxCarousel';

export default withGalleryLightBoxCarouselProps(GalleryLightBoxCarousel);
